/*
 * File: c:\Users\j.mazat\Desktop\mobybuy_front\src\Theme\Component\ButtonCustom.tsx
 * Project: c:\Users\j.mazat\Desktop\mobybuy_front
 * Created Date: Tuesday June 18th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 15th July 2024 04:28:59
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

// import { StyledComponentType } from "Types/ThemeTypes.type";
import styled from "styled-components";

const ButtonCustom = styled.button.attrs((props: any) => {
    return {
        ...props,
        className: `btn btn-primary`,
    }
}
)`
border: 0;
color: white;
background-color: var(--root-colors-first);
&:disabled {
    color: var(--root-colors-first);
    border: 1px solid var(--root-colors-first);
    background-color: rgba(0, 0, 0, 0);
}
`;

export default ButtonCustom;
